import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

interface Props {
    title: string
    subtitle: string
    className?: string
}

const EmptyPanel = ({ title, subtitle, className }: Props) => {
    const theme = useTheme()
    return (
        <Grid
            className={className}
            container
            direction="column"
            justifyContent="center"
            sx={{ height: "100%" }}
        >
            <Grid item>
                <Typography
                    variant="h6"
                    align="center"
                    gutterBottom={true}
                    color={theme.palette.text.disabled}
                >
                    {title}
                </Typography>
                <Typography variant="subtitle1" align="center" color={theme.palette.text.disabled}>
                    {subtitle}
                </Typography>
            </Grid>
        </Grid>
    )
}

export default EmptyPanel
